import styled from 'styled-components';

const SContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default SContainer;
